import React from 'react';
import TablaTerritorios_Cabecera from './TablaTerritorios_Cabecera';
import TablaTerritorios_Cuerpo from './TablaTerritorios_Cuerpo';

const TablaTerritorios = ({ data }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: '14rem', width: '100%' }}>
      <TablaTerritorios_Cabecera />
      <TablaTerritorios_Cuerpo data={data} />
    </div>
  );
};

export default TablaTerritorios;
